import React, {useEffect, useState} from "react"
import Styles from "./fpIframe.less"
import useScript from "react-script-hook"
import {establishLink} from "./webSocket"
import {connect, useDispatch} from "react-redux"
import {State} from "../../store/store"
import closeImg from "./closeImg.svg"
import {isEmpty} from "lodash-es"

const ErrorCode = -1

const FpIframe = (props: any) => {
    const dispatch = useDispatch()
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [scoketLoading, scoketErrorState] = useScript({
        src: "https://img-expense.piaozone.com/static/gallery/socket.io.js",
        checkForExisting: true,
    })
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [pwbScoketLoading, pwbScoketErrorState] = useScript({
        src: "https://img-expense.piaozone.com/static/public/js/pwy-socketio-v2.js",
        checkForExisting: true,
    })
    const [pwyWebsocket, setPwyWebsocket]: any = useState(null)
    const [iframe, setIframe]: any = useState(null)
    let pwyWebSocket: any = null
    useEffect(() => {

        /**
         * fpParam 后端传入的调用发票云选择发票界面的参数
         * @constructor
         * @param {string} baseUrl -测试环境或正式环境的url前缀
         * @param {string} env -"prod"||"test" 测试或正式环境标志
         * @param {string} tin -获取userKey时的税号
         * @param {string} eid -获取userKey时的用户eid
         * @param {string} client_id -发票云分配的client_id
         * @param {string} sign -签名
         * @param {string} timestamp -生成签名时的时间戳
         * @param {string} linkKey -linkKey
         * @param {string} userKey -userKey
         */
        if (props.showFpIframe === true) {
            if (!pwbScoketLoading) {
                pwyWebSocket = establishLink(props.fpParam, sendfpParam, renderIframe)
            } else {
                console.error("加载外部文件或建立socket链接失败")
            }
        }
    }, [props.showFpIframe])
    const sendfpParam = async (fpParam: any) => {
        pwyWebSocket && pwyWebSocket.close()
        setIframe(null)
        props.onSubmit(fpParam)
    }
    const handleClose = () => {
        pwyWebSocket && pwyWebSocket.close()
        setIframe(null)
        dispatch({
            type: "showFpIframe",
            payload: {status: false, type: "FP", param: {}, fpInvokeData: ""},
        })
    }
    const renderIframe = (userKey: any, linkKey: any) => {
        if (!isEmpty(props.fpParam) && userKey !== "" && linkKey !== "") {
            if (props.showFpType === "FP") {
                setIframe(
                    <iframe
                        style={{width: 800, height: 500}}
                        src={
                            // useKer与linkKey实时获取 Param 1100 为PC端调用格式   sourceType 设置为 socket 打开选择发票界面接口请求地址
                            `${props.fpParam.baseUrl}/m4-web/fpzs/index?userKey=${userKey}&linkKey=${linkKey}&gridParam=1100&sourceType=socket`
                            // `https://api-dev.piaozone.com/test/m4-web/fpzs/index?userKey=abfcb9d62406227743cd57937160d736&linkKey=d40655ec4b2a4ffcba94c780294663ab&gridParam=1100&sourceType=socket`
                        }
                    />
                )
            }
            if (props.showFpType === "PJ") {
                setIframe(
                    <iframe
                        style={{width: 800, height: 500}}
                        src={
                            // useKer与linkKey实时获取 Param 1100 为PC端调用格式   sourceType 设置为 socket 打开选择发票界面接口请求地址
                            // `${props.fpParam.baseUrl}/m4-web/ticket/wap/index?userKey=${userKey}&socketName=${linkKey}&model=yes&app=qywx&wechatCard=false&attach=no`
                            `${props.fpParam.baseUrl}/m4-web/fpzs/index?userKey=${userKey}&linkKey=${linkKey}&gridParam=1100&sourceType=socket`
                            // `https://api-dev.piaozone.com/test/m4-web/fpzs/index?userKey=abfcb9d62406227743cd57937160d736&linkKey=d40655ec4b2a4ffcba94c780294663ab&gridParam=1100&sourceType=socket`
                        }
                    />
                )
            }
        }
    }
    return (
        <div className={Styles.mark} style={{display: props.showFpIframe === true ? "flex" : "none"}}>
            <div className={Styles.iframeBox}>
                <div className={Styles.closeImg}>
                    <img onClick={handleClose} src={closeImg} alt={""} />
                </div>
                {/* <iframe*/}
                {/*    style={{width: 800, height: 500}}*/}
                {/*    src={*/}
                {/*        // useKer与linkKey实时获取 Param 1100 为PC端调用格式   sourceType 设置为 socket 打开选择发票界面接口请求地址*/}
                {/*        // `${props.fpParam.baseUrl}/m4-web/fpzs/index?userKey=${userKey}&linkKey=${linkKey}&gridParam=1100&sourceType=socket`*/}
                {/*        `https://api-dev.piaozone.com/test/m4-web/fpzs/index?userKey=abfcb9d62406227743cd57937160d736&linkKey=d40655ec4b2a4ffcba94c780294663ab&gridParam=1100&sourceType=socket`*/}
                {/*    }*/}
                {/* />*/}
                {iframe}
            </div>
        </div>
    )
}

export default connect((state: State) => {
    return {
        showFpIframe: state.showFpIframe,
        showFpType: state.showFpType,
        fpParam: state.fpParam,
    }
})(FpIframe)
